import React from 'react';
import { useHistory } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { format, parseISO } from 'date-fns';
import { compareLinkForDoc, publishedVersionLabel } from './versionApi';

// Compare view header (RES-561), per the Idea-2 XD design: one row — Previous Doc,
// then the document title with its type as a pill badge, publish date and author,
// then Next Doc — separated by thin vertical rules. Prev/Next iterate the document
// list handed over via location.state by the library entry point
// (compareDocs/compareIndex) and are hidden otherwise — the singleDocViewer pattern.
// The author is the LEFT pane's author (`author` prop, 2026-08-17 feedback item 5)
// — NOT focalDoc's, which can be the right pane's published doc when the left holds
// the current draft.

const safeDate = (iso) => {
	try {
		return format(parseISO(iso), 'dd/MM/yyyy');
	} catch (e) {
		return null;
	}
};

const CompareHeader = ({ templateName, ticker, focalDoc, author, navDocs, navIndex }) => {
	const history = useHistory();
	const hasNav = Array.isArray(navDocs) && navDocs.length > 0 && navIndex >= 0;
	const showPrev = hasNav && navIndex > 0;
	const showNext = hasNav && navIndex < navDocs.length - 1;

	const goTo = (index) => {
		const link = compareLinkForDoc(navDocs, index);
		if (link)
			history.push(link);
	};

	// The focal document names the comparison; without one (deep link straight to a
	// draft pair) the tickerKey stands in as the title.
	const date = focalDoc ? safeDate(focalDoc.date) : null;
	// Unnumbered docs (null major — pre-v80 or offline-recorded publishes) show no
	// version badge; the ".0 of its major" convention lives in publishedVersionLabel.
	const versionBadge = publishedVersionLabel(focalDoc);

	return (
		<div className="compare-header">
			{showPrev && (
				<>
					<button type="button" className="compare-header-nav" onClick={() => goTo(navIndex - 1)}>
						<ChevronLeft size={20} />
						Previous Doc
					</button>
					<span className="compare-header-divider" />
				</>
			)}
			<div className="compare-header-group">
				<h3 className="compare-header-title">{(focalDoc && focalDoc.title) || ticker}</h3>
				<span className="compare-header-badge">{templateName}</span>
				{versionBadge && <span className="compare-header-badge">{versionBadge}</span>}
			</div>
			{date && (
				<>
					<span className="compare-header-divider" />
					<span className="compare-header-item">{date}</span>
				</>
			)}
			{author && (
				<>
					<span className="compare-header-divider" />
					<span className="compare-header-item">{author}</span>
				</>
			)}
			{showNext && (
				<>
					<span className="compare-header-divider" />
					<button type="button" className="compare-header-nav" onClick={() => goTo(navIndex + 1)}>
						Next Doc
						<ChevronRight size={20} />
					</button>
				</>
			)}
		</div>
	);
};

export default CompareHeader;
